module.exports = __webpack_public_path__ + "static/img/copy-share-word.40d0c6bb.png";